import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { Flex, LineChart, formatPercentage } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import { useChartPeriod } from '@/hooks';

export default function HistoricTabs({ ilk }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');

  const [data, error] = useApi({
    url: `/groups/core/ilks/${ilk}/parameters/stability-fee/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();

  if (data) {
    return (
      <Flex flexDirection="column" gap="m">
        <LineChart
          key={'total'}
          data={data}
          datasets={[
            {
              xField: 'date',
              yField: 'stability_fee'
            }
          ]}
          yScaleValueFormatter={(value) => `${formatPercentage(Number(value))}`}
          valueFormatter={(value) => `${formatPercentage(Number(value))}`}
          timeFilter={timeFilter}
          config={config}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
